/** Overrides **/
var darkerNav = () => {
    let darker = document.getElementById('darker')
    if(darker == null) return
    jQuery('#nav2 .dropdown').hover(() => {
        if (!darker.classList.contains('active')) darker.classList.add('active');
    }, () => { 
        if (darker.classList.contains('active')) darker.classList.remove('active');
    });
}

const closeDialogOld = closeDialog;
window.closeDialog = () => {
    if(window.parent && window.parent.document.querySelector('.offcanvas-container.state--visible') != null) {
        window.parent.closeOffCanvas();
    } else if(window.self !== window.top) {
        window.parent.closeDialog();
    } else if(document.querySelector('.offcanvas-container.state--visible') != null) {
        closeOffCanvas();
    } else {
        closeDialogOld();
    }
}

/** Custom **/
window.sliders = [];

// Slide Down
const slideDown = el =>  {
    el.classList.add('state--maximised');
    el.style.height = `${el.scrollHeight}px`;
}

// Slide Up
const slideUp = el => {
    el.classList.remove('state--maximised');
    el.style.height = 0;
}

// Toggle Slide Up / Slide Down
const slideToggle = (el) => {
    if(el.style.height == '0px') {
        slideDown(el)
    } else {
        slideUp(el)
    }
}

const minimiser = () => {

    let minimisers = document.querySelectorAll('.btn-minimise');
    if(minimisers == null) return;
    minimisers.forEach(minimiser => {

        minimiser.addEventListener('click', () => {
            if(minimiser.closest('.minimisable') != null) {
                slideUp(minimiser.closest('.minimisable'));
            }
        })

    })

}

// Create anchor so we can grab relative paths
const createAnchor = (url) => {
    let a = document.createElement('a');
    a.href = url;
    return a;
}

// Split BP actions into component parts, change to regex
const getBPActionParts = (actionString) => {
    let actionParts = actionString.replace('doAction(', '').replace(');', '').replace(/'/g, '').split(', ');
    return actionParts;
}

// Window loaded events - todo: move/clean
window.addEventListener('DOMContentLoaded', () => {

    const hamburgerBtn = document.querySelector('.site-hamburger button')

    if(hamburgerBtn != null) hamburgerBtn.addEventListener('click', (e) => {
        e.preventDefault()
        e.stopPropagation()
        hamburger()
    })

    const offCanvasTriggers = document.querySelectorAll('.offcanvas-trigger')
    if(offCanvasTriggers.length) {
        offCanvasTriggers.forEach((el) => {
            el.addEventListener('click', (e) => {
                if(el.classList.contains('state--triggered')) return
                openOffCanvas(el)
            })
        })
    }

    const offCanvasOverlay = document.querySelector('.offcanvas-overlay')
    if(offCanvasOverlay != null) offCanvasOverlay.addEventListener('click', (e) => {
        e.preventDefault()
        e.stopPropagation()
        closeOffCanvas()
    })

    minimiser();

})

// Get viewport width and height for Swiper etc.
const viewportDimensions = () => {
    return {
        width: Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0),
        height: Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0)
    }
}

// Open off canvas content
window.openOffCanvas = (el) => {
    if(typeof el == 'undefined' || el == null || el.dataset.content == null || el.dataset.content == '') {
        console.log('Element not configured correctly', el);
        return;
    }
    if(el.classList.contains('state--triggered')) {
        console.log('Element already triggered', el);
        return;
    }
    let content = document.querySelector(el.dataset.content);
    if(content == null) {
        console.log('Content doesn\'t exist for', el);
        return;
    }
    el.classList.add('state--triggered');
    let overlay = document.querySelector('.offcanvas-overlay');
    let offcanvas = document.querySelector('.offcanvas-container');
    let offCanvasContent = document.querySelector('.offcanvas-content');
    let offCanvasTitle = offcanvas.querySelector('h4');
    let slug = content.dataset.title.replace(/[^a-zA-Z0-9\s]/g, '').replace(' ', '-').toLowerCase();
    offcanvas.dataset.slug = slug;
    offCanvasTitle.textContent = content.dataset.title;
    if(el.dataset.flash == 'true') {
        offCanvasTitle.classList.add('state--flash');
        setTimeout(() => {
            offCanvasTitle.classList.remove('state--flash');
        }, (typeof el.dataset.flashTimer != 'undefined' ? el.dataset.flashTimer : 2500));
    }
    overlay.classList.add('state--visible');
    offcanvas.dataset.trigger = el.dataset.content;
    offCanvasContent.append(content);
    offcanvas.classList.add('state--visible');
    if(typeof bodyfix != undefined) bodyFix();
}

// Close off canvas content
window.closeOffCanvas = () => {
    let overlay = document.querySelector('.offcanvas-overlay');
    let offcanvas = document.querySelector('.offcanvas-container');
    let offCanvasContent = document.querySelector('.offcanvas-content');
    let contentContainer = document.querySelector('.offcanvas-content-holder');
    let content = document.querySelector('.offcanvas-content > *');
    let triggers = document.querySelectorAll('[data-content="'+offcanvas.dataset.trigger+'"]');
    offcanvas.querySelector('h4').textContent = '';
    offcanvas.dataset.slug = '';
    overlay.classList.remove('state--visible');
    offcanvas.classList.remove('state--visible');
    if(content != null) contentContainer.append(content);
    if(triggers != null) {
        triggers.forEach((trigger) => trigger.classList.remove('state--triggered'));
    }
    if(typeof bodyUnfix != undefined) bodyUnfix();
}

const accountButton = (el) => {
    if(isLoggedIn) {
        el.dataset.content = '.offcanvas-account';
        openOffCanvas(el);
    } else {
        openOffCanvas(el);
    }
}

// Scroll classes on body - todo: move/clean
window.addEventListener('DOMContentLoaded', (e) => {

    window.hasScrolled = false;
    document.addEventListener('scroll', (e) => {
        window.hasScrolled = true;
    })

    let lastScrollPos = window.scrollY;
    let delta = 5;
    let el = document.querySelector('.site-header');
    let elHeight = el.offsetHeight;
    let loadedScrolled = lastScrollPos > 0;

    if(lastScrollPos > 0) hasScrolled = true;

    setInterval(() => {
        if(window.hasScrolled) {
            lastScrollPos = scrollEvents(0, 500, lastScrollPos, delta, loadedScrolled);
            window.hasScrolled = false;
        }
    }, 200)

})

const scrollEvents = (elHeight, offset, lastScrollPos, delta, loadedScrolled) => {
    scrollPos = window.scrollY

    if(scrollPos == 0) {
        document.body.classList.remove('state--scrolled', 'state--scrolled-up', 'state--scrolled-down')
        return
    }
    
    if(Math.abs(lastScrollPos - scrollPos) <= delta && !loadedScrolled) {
        document.body.classList.remove('state--scrolled')
        return
    }

    document.body.classList.add('state--scrolled')

    if(scrollPos >= lastScrollPos && scrollPos > elHeight) {
        document.body.classList.remove('state--scrolled-up')
        document.body.classList.add('state--scrolled-down')
    } else {
        document.body.classList.remove('state--scrolled-down')
        document.body.classList.add('state--scrolled-up')
    }

    if(scrollPos > offset) {
        document.body.classList.add('state--scrolled-offset')
    } else {
        document.body.classList.remove('state--scrolled-offset')
    }

    return scrollPos
}

/** check for login */
const checkLogin = () => {
    // return if can't check logged in
    if(typeof isLoggedIn === 'undefined') return false;
    // return if not logged in  
    if(isLoggedIn == false) {
        document.querySelector('.site-header button.account').click();
        return false;
    }
    return true;
}

// Wishlist
window.addEventListener('DOMContentLoaded', (e) => {

    let wishlistButtons = document.querySelectorAll('.site-wishlist > a');
    if(wishlistButtons != null) wishlistButtons.forEach(wishlistButton => {
        wishlistButton.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            if(checkLogin()) {
                window.location.href = wishlistButton.href;
            }
        });
    });

})

/** copying minimal BP functionality to customize wishlist behaviour */
const doWishCustom = (el) => {
    if(!checkLogin()) return;
    let card = el.closest('.product-card');
    let data;
    let actions;
    if(card != null) {
        let origButton = card.querySelector('.product_icon');
        actions = origButton.getAttribute('onclick').replace('doWish(', '').replace(');', '').replace(/'/g, '').split(', ');
    } else {
        actions = [
            el.dataset.productUrl,
            jQuery('form[name=details]').serialize() + '&addajax=1'
        ];
    }
    data = actions[1];
    data = data.replace(/action=add/, 'action=addwish');
    let wishImg = el.querySelector('span.icon');
    // run action, using jQuery becase BP uses it
    jQuery.post(actions[0], data, (response) => {
        if (response.substr(0, 4) != 'http') {
            response = JSON.parse(response);
            if(response.wishlist_items != '0') {
                wishImg.classList.add('pulse', 'state--wishlist-added');
                setTimeout(() => {
                    wishImg.classList.remove('pulse');
                }, 1000);
            } else {
                
            }
        }
    })
}

const checkWishAdded = (selector = '') => {

    let added = document.querySelectorAll('.bp-icon-heart-b')
    let selectors = []
    if(typeof selector != 'undefined' && selector != '') selectors.push(selector)
    selectors.push('.product-card', '.product-add')
    
    added.forEach((wishlisted) => {

        let container = null
        for(i=0;i<selectors.length;i++) {
            container = wishlisted.closest(selectors[i])
            if(container != null) {
                break
            }
        }
        if(container == null) return
        let wishImg = container.querySelector('.product-wishlist span.icon')
        if(wishImg != null) wishImg.classList.add('state--wishlist-added')
        
    })

}

// Form validation - todo: move/clean
window.addEventListener('DOMContentLoaded', (e) => {

    setupForms('.form')

})

const setupForms = (selector) => {

    let forms = document.querySelectorAll(selector);
    if(forms == null) return;

    forms.forEach((form) => {

        let labels = form.querySelectorAll('.label');
        let addressFields = ['companyname', 'address1', 'address2', 'towncity', 'county', 'postcode', 'country'];
        wrapTextNodes(form, 'hidden');
        
        labels.forEach((label) => {
            let wrap = label.parentNode;
            let required = wrap.querySelector('.required');
            let input = wrap.querySelector('textarea') != null ? wrap.querySelector('textarea') : wrap.querySelector('select') != null ? wrap.querySelector('select') : wrap.querySelector('input');
            
            wrap.dataset.field = true;
            if(required != null || input.name == 'delivery') {
                wrap.dataset.required = 'true';
            } else {
                wrap.dataset.required = 'false';
                label.innerHTML = label.innerHTML + '<span class="optional italic"> - optional</span>';
            }
            doValidation(input, wrap, null, true);
            wrap.addEventListener('keyup', e => { doValidation(input, wrap, e) });
            wrap.addEventListener('focus', e => { doValidation(input, wrap, e) });
            wrap.addEventListener('focusout', e => { doValidation(input, wrap, e) });
            wrap.addEventListener('click', e => { doValidation(input, wrap, e) });

        })

        document.addEventListener('click', e => {
            if(!e.target.classList.contains('.pcaitem') && e.target.closest('.pcaitem') == null) return;
            setTimeout(() => {
                addressFields.forEach(addressField => {
                    let input = document.getElementById(addressField);
                    if(input == null) return;
                    let wrap = input.parentNode;
                    doValidation(input, wrap, e);
                })
            }, 100);
        })

    })

}

const doValidation = (input, wrap, event, firstLoad) => {
    let tagType;
    let eventType = 'none';
    let value;
    if(typeof event != 'undefined' && event != null) {
        eventType = event.type;
        if(eventType == 'keyup' || eventType == 'focus' || eventType == 'focusout') {
            wrap.dataset.interacted = true;
        }
        wrap.dataset.lastEvent = eventType;
    }
    // Don't know why we would get null results for fields but return in case
    if(input == null) {
        return;
    }
    tagType = input.tagName.toLowerCase();
    if(tagType == 'input') {
        tagType = tagType + '-' + input.type.toLowerCase();
    }
    wrap.dataset.inputType = tagType;
    value = input.value;
    if(typeof input.type != 'undefined' && input.type != 'checkbox' && input.type != 'radio') {
        if((eventType != 'click' && !!wrap.dataset.interacted == true) || tagType == 'select' || firstLoad) {
            if(value == '' || (tagType == 'select' && value == 0)) {
                wrap.dataset.valid = false;
            } else {
                wrap.dataset.valid = true;
            }
        }
    }
    if(wrap.querySelector('#cardNumber, #cardExpiry, #cardCvc') != null) {
        wrap.dataset.interacted = true;
        wrap.dataset.valid = true;
        wrap.dataset.stripeElement = true;
    }
}

// Until Bluepark stops outputting random text without a wrapper we need this
const wrapTextNodes = (parent, cssClass) => {
    
    let textNodes = Array.from(parent.childNodes).filter(node => node.nodeType === 3/* && node.textContent.trim().length > 1*/);

    textNodes.forEach((node, i) => {
        const span = document.createElement('span');
        if(typeof cssClass != 'undefined' && cssClass != null) {
            span.classList.add(cssClass, cssClass + '-' + i);
        }
        span.classList.add('text-node');
        node.after(span);
        span.appendChild(node);
    })

}

// Bluepark add to basket
const doOffcanvasBasket = (actionUrl, data, el) => {
    let basketContainer = document.querySelector('.offcanvas-basket')
    if(typeof basketContainer.dataset.actionUrl == 'undefined') {
        basketContainer.dataset.actionUrl = window.location.pathname;
    }
    jQuery.post(actionUrl, data, (response) => {
        if (response.substr(0, 4) != 'http') {
            response = jQuery.parseJSON(response);
            if ((response.dialog1) && (response.dialog2) && (actionUrl.indexOf('silent=1') < 0)) {
                basketContainer.innerHTML = '';
                let tempBasket = formatOffcanvasBasket(response, basketContainer.dataset.actionUrl);
                basketContainer.append(tempBasket);
                el.dataset.flash = true;
                el.dataset.flashTimer = 2500;
                openOffCanvas(el);
            }
            jQuery('.basket_totalitems').html(response.basket_totalitems);
            jQuery('.basket_viewitems').html(response.basket_viewitems);
            jQuery('.basket_items').html(response.basket_items);
            jQuery('.basket_total').html(response.basket_total);
            jQuery('.basket_totalex').html(response.basket_totalex);
            jQuery('.basket_subtotal').html(response.basket_subtotal);
            jQuery('.basket_subtotalex').html(response.basket_subtotalex);
            if (typeof hookBasket == 'function') hookBasket();
            if ((response.added_google == '1') && (response.added_sku) && (typeof gtag != 'undefined'))
            {
                gtag('event', 'add_to_cart',
                {
                    'items':
                    [{
                        'id': response.added_sku,
                        'name': response.added_title,
                        'variant': response.added_variant,
                        'brand': response.added_brand,
                        'quantity': response.added_quantity,
                        'price': response.added_price
                    }]
                });
            }
            if ((response.added_facebook == '1') && (response.added_sku) && (typeof fbq != 'undefined'))
            {
                fbq('track', 'AddToCart',
                {
                    'value': response.added_price,
                    'currency': response.added_currency,
                    'content_name': response.added_title,
                    'content_type': 'product',
                    'contents':
                    [{
                        'id': response.added_sku,
                        'quantity': response.added_quantity
                    }]
                });
            }
            if ((response.added_pinterest == '1') && (response.added_sku) && (typeof pintrk != 'undefined'))
            {
                pintrk('track', 'addtocart',
                {
                    'value': response.added_price,
                    'order_quantity': response.added_quantity,
                    'currency': response.added_currency,
                    'line_items':
                    [{
                        'product_id': response.added_sku,
                        'product_name': response.added_title,
                        'product_quantity': response.added_quantity,
                        'product_price': response.added_price
                    }]
                });
            }
            if ((response.added_klaviyo == '1') && (response.added_sku) && (typeof _learnq != 'undefined'))
            {
                _learnq.push(['track', 'Added to Cart',
                {
                    '$value': response.added_price * response.added_quantity,
                    'AddedItemPrice': response.added_price,
                    'AddedItemQuantity': response.added_quantity,
                    'AddedItemProductName': response.added_title,
                    'AddedItemSKU': response.added_sku,
                    'Items':
                    [{
                        'SKU': response.added_sku,
                        'ProductName': response.added_title,
                        'Quantity': response.added_quantity,
                        'ItemPrice': response.added_price,
                        'RowTotal': response.added_price * response.added_quantity
                    }]
                }]);
            }
        }
    })
}

const formatOffcanvasBasket = (response, actionUrl) => {

    let el = document.createElement('div');
    el.classList.add('offcanvas-basket-inner');
    el.innerHTML = response.dialog1;
    let imgs = el.querySelectorAll('.fixed');
    let qtys = el.querySelectorAll('.dialog_quantity');

    // Check for addable products
    let products = document.querySelector('.offcanvas-products')
    if(products != null) {
        let productsContainer = document.createElement('div');
        productsContainer.classList.add('flx', 'flex-col', 'dialog_recommended');
        productsContainer.innerHTML = '<h4 class="font-16 font-bold uppercase tracking-tighter">Recommended for you:</h4>';
        let productsCopy = products.cloneNode(true);
        productsCopy.style.display = 'block';
        productsContainer.append(productsCopy);
        el.querySelector('.dialog_wrap').append(productsContainer);
    }

    // Remove/modify existing elements
    el.querySelector('#closedialog').remove();
    el.querySelector('.dialog_header').remove();
    el.querySelector('.dialog_buttons').before(el.querySelector('.dialog_footer'));
    el.querySelector('.dialog_buttons button:first-child').setAttribute('onclick', 'closeOffCanvas();');

    // Add payment logos
    let payments = document.createElement('div');
    payments.classList.add('dialog_payments', 'flx', 'items-center', 'justify-center');
    payments.innerHTML = '<img src="/templates/pursuit-gp-2023/img/icons/icon-payments.svg" width="202" height="24" alt="Payments accepted" />';
    el.querySelector('.dialog_buttons').append(payments);

    // Append basket message if there is one
    if(response.basket_message != '') {
        let basketMessage = document.createElement('div');
        basketMessage.classList.add('dialog_message', 'block');
        if(response.basket_message.indexOf('limited') > -1) {
            basketMessage.classList.add('state--error')
        }
        basketMessage.innerHTML = `<p class="font-1x">${response.basket_message}</p>`;
        el.querySelector('.dialog_wrap').before(basketMessage);
        setTimeout(() => {

        }, 4000);
    }

    // Remove fixed class from images and add more appropriate one because why are they even fixed in the first place???
    imgs.forEach(img => {
        img.classList.remove('fixed');
        img.classList.add('dialog_image');
    })

    // Loop quantity elements
    qtys.forEach((qty, i) => {

        if(qty.querySelector('.quantity_sub[onclick]') == null) return;

        // Set up properties
        let qtyInput = qty.querySelector('div:nth-child(2)');
        let qtySub = qty.querySelector('.quantity_sub');
        let qtyValue = parseInt(qtyInput.textContent);
        let qtySelect = document.createElement('select');

        // Set up new select
        for(i=0;i<11;i++) {
            qtySelect.innerHTML += `<option value="${i}">${i}</option>`;
        }
        qtySelect.value = qtyValue;
        qtySelect.dataset.oldValue = qtyValue;
        qtySelect.addEventListener('change', (e) => {
            
            // set value
            let newValue = qtySelect.value;

            // set options
            let options = { 
                action: 'qty',
                value: newValue,
                data: `addajax=1`
            };

            // Get current action arguments
            let qtyActionParts = getBPActionParts(qtySub.getAttribute('onclick'));
            let qtyActionPart = qtyActionParts[2].replace(/[as]{1}=([0-9]{1,4})/, "c=$1");

            // Set urls
            let newActionUrl = `/index/action/basket/${qtyActionPart}&quantity=${newValue}&silent=1`;
            let newActionUrl2 = `${actionUrl}${qtyActionPart}&quantity=${newValue}`;

            options['additionalAction'] = newActionUrl2;

            updateOffcanvasBasket(newActionUrl, options);
            qtySelect.dataset.oldValue = qtySelect.value;

        })
        
        qty.innerHTML = ''
        qty.append(qtySelect)

    })

    // Return element in case
    return el

}

const updateOffcanvasBasket = (actionUrl, options) => {
    let basketContainer = document.querySelector('.offcanvas-basket')
    
    jQuery.post(actionUrl, options.data, (response) => {
        if (response.substr(0, 4) != 'http') {
            response = jQuery.parseJSON(response);
            if(options.action == 'qty' && typeof options.additionalAction != 'undefined') {
                console.log(options.additionalAction);
                // Run another update because we can't directly change quantities from the product page
                jQuery.post(options.additionalAction, options.data, (response2) => {
                    if (response2.substr(0, 4) != 'http') {
                        response2 = jQuery.parseJSON(response2);
                        basketContainer.innerHTML = '';
                        if ((response2.dialog1) && (response2.dialog2)) {
                            response2.basket_message = response.basket_message;
                            let tempBasket = formatOffcanvasBasket(response2, basketContainer.dataset.actionUrl);
                            basketContainer.append(tempBasket);
                            let offCanvasContainer = basketContainer.closest('.offcanvas-container');
                            let offCanvasTitle = offCanvasContainer.querySelector('.offcanvas-title h4');
                            offCanvasTitle.classList.add('state--flash');
                            setTimeout(() => {
                                offCanvasTitle.classList.remove('state--flash');
                            }, 2500);
                        } else {
                            closeOffCanvas()
                            return
                        }
                    }
                })
            }
            if ((response.dialog1) && (response.dialog2)) {
                basketContainer.innerHTML = ''
                if(response.dialog1 == '') {
                    closeOffCanvas()
                    return
                }
                let tempBasket = formatOffcanvasBasket(response, basketContainer.dataset.actionUrl)
                basketContainer.append(tempBasket)
            }
            jQuery('.basket_totalitems').html(response.basket_totalitems);
            jQuery('.basket_viewitems').html(response.basket_viewitems);
            jQuery('.basket_items').html(response.basket_items);
            jQuery('.basket_total').html(response.basket_total);
            jQuery('.basket_totalex').html(response.basket_totalex);
            jQuery('.basket_subtotal').html(response.basket_subtotal);
            jQuery('.basket_subtotalex').html(response.basket_subtotalex);
        }
    })
    
}

// Product add to cart loop
const doLoopAdd = (url, sku, el) => {
    let a = createAnchor(url);
    let path = a.pathname.replace('.html', '');
    let actionUrl = `${path}/action/add/product/${sku}/`;
    doOffcanvasBasket(actionUrl, 'addajax=1', el);
}

const doProductAdditionalActions = (url, action, sku, el) => {
    let title
    if(['notify', 'friend'].indexOf(action) < 0) return;
    if(action == 'friend') {
        title = 'Tell a friend';
    }
    if(action == 'notify') {
        title = 'Notify me';
    }
    let slug = title.replace(/[^a-zA-Z0-9\s]/g, '').replace(' ', '-').toLowerCase();
    let a = createAnchor(url);
    let path = a.pathname.replace('.html', '')
    let actionUrl = `${path}/action/${action}/product/${sku}/?quickview=1&triggerId=${slug}`;
    el.dataset.content = '.offcanvas-iframe';
    let iframeContainer = document.querySelector('.offcanvas-iframe');
    iframeContainer.dataset.title = title;
    iframeContainer.querySelector('iframe').src = actionUrl;
    openOffCanvas(el)
}

// 
window.addEventListener('DOMContentLoaded', () => {

    let quickview = document.querySelector('body#quickview');
    if(quickview == null) return;

    let backButtons = document.querySelectorAll('button[name="back"]');

    backButtons.forEach(backButton => {
        backButton.setAttribute('onclick', 'window.parent.closeOffCanvas(); return false;');
    })

})

const formatStockStatus = () => {

    let gaps = document.querySelectorAll('.col_title .gap')
    gaps.forEach(gap => {
        let text = gap.textContent.toLowerCase()
        if(text.indexOf('stock') > -1) {
            gap.classList.add('stock-status')
            if(/[0-9]+\sin/.test(text)) {
                gap.classList.add('stock-status-low')
            } else {
                gap.classList.add('stock-status-good')
            }
        }
    })

}

const searchTrigger = () => {
    
    let search = document.querySelector('.site-search');
    if(search == null) return;
    let searchInput = search.querySelector('input');
    let searchBtn = search.querySelector('.search_button');
    let searchClose = search.querySelector('.btn-search-close');
    let darker = document.getElementById('darker');

    searchInput.addEventListener('focus', () => {
        searchOpen();
    });

    searchBtn.addEventListener('click', (e) => {
        e.preventDefault();
    });

}

const searchClose = () => {

    let search = document.querySelector('.site-search');
    let darker = document.getElementById('darker');
    search.classList.remove('state--focus');
    darker.classList.remove('active');
    jQuery('.autocomplete').next('.suggestions').hide();
    jQuery('.autocomplete').next('.suggestions').find('.swiper-wrapper').html('');
    jQuery('.site-search input').val('');
    jQuery('.search-go').hide();
    if(typeof bodyUnfix != 'undefined') bodyUnfix();

}

const searchOpen = () => {

    let search = document.querySelector('.site-search');
    let darker = document.getElementById('darker');
    search.classList.add('state--focus');
    darker.classList.add('active');
    if(typeof bodyFix != 'undefined') bodyFix();

}

const searchSlider = () => {

    return new Swiper('.suggestions .swiper', {
        slidesPerView: 'auto',
        slidesOffsetBefore: 18,
        slidesOffsetAfter: 18,
        mousewheel: {
            forceToAxis: true
        },
        freeMode: true,
        navigation: {
            nextEl: '.suggestions .swiper-button-next',
            prevEl: '.suggestions .swiper-button-prev'
        },
        breakpoints: {
            835: {
                slidesOffsetBefore: 84,
                slidesOffsetAfter: 30
            },
            1608: {
                slidesOffsetBefore: function() {
                    vp = viewportDimensions();
                    return (((vp.width - 1608) / 2) + 84);
                },
                slidesOffsetAfter: 30
            }
        }
    });

}

autocomplete = (field, del, min) => {
    field = jQuery(field);
    field.wrap('<div class="site-search-inner"></div>').wrap('<div class="autocomplete"></div>');
    jQuery('.autocomplete').after('<div class="suggestions"><div class="swiper"><div class="swiper-wrapper"></div></div><div class="swiper-button-prev"></div><div class="swiper-button-next"></div></div><div class="search-go"></div>');
    jQuery('.search_button').detach().appendTo('.autocomplete');
    jQuery('.autocomplete').append('<button type="button" class="btn-none btn-search-close" onclick="searchClose()"></button>');
    jQuery('.search_button').clone().html('Show all results').removeClass('search_button').addClass('search_go').appendTo('.search-go');
    var suggestions = jQuery('.autocomplete').next('.suggestions');
    var searchGo = suggestions.next('.search-go');
    var suggestionsWrap = jQuery('.autocomplete').next('.suggestions').find('.swiper-wrapper');
    var breakpoint = window.matchMedia('(min-width: 835px)');
    window.sliders['search'] = searchSlider();
    if(!breakpoint.matchMedia) window.sliders['search'].destroy(true, true);
    breakpoint.addEventListener('change', (breakpoint) => {
        if(breakpoint.matches === true) {
            window.sliders['search'] = searchSlider();
        } else {
            if(typeof window.sliders['search'] != 'undefined') {
                window.sliders['search'].destroy(true, true);
                delete window.sliders['search'];
            }
        }
    })
    if(breakpoint.matches === true) window.sliders['search'] = searchSlider();
    field.keyup(delay(function()
    {
        if (jQuery(this).val().length >= min)
        {
            jQuery.ajax(
            {
                url: '/includes/autocomplete.php',
                dataType: 'json',
                data:
                {
                    term: jQuery(field).val(),
                    langid: jQuery('form[name="languages"] select').length ? jQuery('form[name="languages"] select').val() : 2,
                    currid: jQuery('form[name="currencies"] select').length ? jQuery('form[name="currencies"] select').val() : 1,
                    userid: null,
                    v: 2
                },
                beforeSend: function()
                {
                    field.addClass('autoloading');
                },
                success: function(data)
                {
                    if (data.length > 0)
                    {
                        field.removeClass('autoloading');
                        suggestions.show();
                        suggestionsWrap.html('');
                        searchGo.show();
                        if(typeof window.sliders['search'] != 'undefined') {
                            if(typeof window.sliders['search'].destroy != 'undefined') {
                                window.sliders['search'].destroy(true, true);
                                delete window.sliders['search'];
                            }
                        }
                        jQuery.each(data, function(index, item)
                        {
                            var offset = item.label.lastIndexOf('<span');
                            if (offset > -1)
                            {
                                offset = item.label.indexOf('>', offset) + 1;
                                var offset2 = item.label.lastIndexOf('</span>');
                                if (offset2 > -1)
                                {
                                    var s = jQuery(field).val().replace(/"/g, '').replace(/\s+$/, '');
                                    var re = new RegExp(s, 'i');
                                    var t = item.label.substr(offset, offset2 - offset);
                                    var tt = t.replace(re, '~~');
                                    var rep = t.substr(tt.indexOf('~~'), s.length);
                                    item.label = item.label.substr(0, offset) + tt.replace(/~~/, '<b>' + rep + '</b>') + item.label.substr(offset2);
                                }
                            }
                            suggestionsWrap.append('<div class="swiper-slide"><a href="/' + item.value + '">' + item.label + '</a></div>');
                        });
                        if(breakpoint.matches === true) window.sliders['search'] = searchSlider();
                        if(typeof window.sliders['search'] != 'undefined') {
                            window.sliders['search'].update();
                            window.dispatchEvent(new Event('resize'));
                        }
                    }
                    else
                    {
                        field.removeClass('autoloading');
                        suggestions.hide();
                        searchGo.hide();
                    }
                },
                error: function(e)
                {
                    field.removeClass('autoloading');
                    suggestions.hide();
                    searchGo.hide();
                }
            });
        }
        else
        {
            field.removeClass('autoloading');
            suggestions.hide();
            searchGo.hide();
            suggestionsWrap.html('');
            if(typeof window.sliders['search'] != 'undefined') window.sliders['search'].update();
        }
    }, del));
    field.focus(function()
    {
        field.removeClass('autoloading');
        if (suggestionsWrap.html().length > 0) {
            suggestions.show();
            searchGo.show();
        }
        if(typeof window.sliders['search'] != 'undefined') window.sliders['search'].update();
    });
    field.add(suggestions).click(function(e)
    {
        e.stopPropagation();
    });
    field.keydown(function(e)
    {
        if (e.keyCode == 13) {

        }
        if (e.keyCode == 27) {
            field.blur();
            field.removeClass('autoloading');
            suggestions.hide();
            suggestionsWrap.html('');
            if(typeof window.sliders['search'] != 'undefined') window.sliders['search'].update();
        }
    });
}

window.addEventListener('DOMContentLoaded', () => {
    searchTrigger();
})

optionChange = (pid, oid) => {
    var selected = 0;
    if (jQuery('.selectfield_' + pid + '_' + pid + '.sequence').length > 1)
    {
        selectFields(pid, pid, oid, 1, 0);
        selected = 1;
    }
    jQuery.post(window.location.href, jQuery('form[name=details]').serialize() + '&optajax=1', function(response)
    {
        response = jQuery.parseJSON(response);
        var cnum = '';
        var cdiv = jQuery('#image').find('.carousel_items').first();
        if (jQuery(cdiv).length) cnum = jQuery(cdiv).attr('class').match(/carousel_\d+/);
        jQuery('#image').replaceWith(response.product_image);
        if (cnum) jQuery('#image').find('.carousel_items').first().addClass(cnum);
        jQuery('#alternate').replaceWith(response.product_alternate);
        if (jQuery('#image').hasClass('lightbox')) lightbox(jQuery('#image')); else jQuery('.lightbox', jQuery('#image')).each(function() { lightbox(this); });
        if (jQuery(cdiv).length) setTimeout(function() { carousel(jQuery('#image')); }, 200);
        var changed = 0;
        var price = jQuery('#price_selling').html();
        if ((price) && (price.replace(/[^0-9\.,]/g, '') != response.product_selling.replace(/[^0-9\.,]/g, ''))) changed = 1;
        var quantity = jQuery('#pquantity').val();
        var properties = {
            'product_selling': 'price_selling',
            'product_list': 'price_list',
            'product_list_label': 'price_list_label',
            'product_saving': 'price_saving',
            'product_saving_label': 'price_saving_label',
            'product_vat': 'inex',
            'product_inexc_value': 'incexc',
            'product_points_number': 'points',
            'product_points_value': 'points_value',
            'product_availability': 'availability',
            'product_notify': 'notify',
            'product_action': 'action',
            'product_quantity': 'quantity',
            'product_add': 'add',
            'product_wishlist_icon': 'wishlist',
            'product_discount': 'discount',
            'product_sku': 'sku',
            'product_barcode': 'bar_code',
            'product_partnumber': 'part_number',
            'product_weight': 'product_weight',
            'vatrate': 'vatrate',
            'vatcalc': 'vatcalc',
            'pointvalue': 'pointvalue',
            'pointbonus': 'pointbonus'
        };
        if(!selected) properties['product_options'] = 'options';
        if(changed == 1) properties['product_paypal'] = 'paypal_message';
        for(let property in properties) {
            let propertyId = properties[property];
            let elements = document.querySelectorAll(`[id='${propertyId}']`);
            if(elements == null) return;
            elements.forEach(element => {
                element.outerHTML = response[property];
            });
        }
        jQuery('#pquantity').val(quantity);
        jQuery('#variant_str').val(response.variant_str);
        jQuery('#pprice').val(response.pprice);
        jQuery('#plprice').val(response.plprice);
        additionPrices();
    });
}